import React, { useEffect } from 'react';
import { Grid, Cell } from '@hyphengroup/cag-components';
import PropTypes from 'prop-types';
import { getPageRoute } from 'helpers/Utils';
import Product from './Product';
import Footer from './Footer';

function Vertical({
  list: { products: verticalProducts, ctaBtnData },
  disclaimerSection,
  seeMoreButton,
  trackCtaClick,
  trackTabChange,
  tabLabel,
  onSeeMoreButtonClick,
  language,
  widgetTitle,
  ccProductPageRoutes,
}) {
  // Make sure only 3 products are ever shown
  const products = verticalProducts.slice(0, 3);
  useEffect(() => {
    trackTabChange?.(products, tabLabel);
  }, []);

  const getCtaButton = (product) => {
    const { ctaButton, functional } = product;
    const { linkVerticalRoute, staticKeys, staticText } = ctaBtnData;
    if (functional) {
      return ({
        label: staticText.find((i) => i.key === staticKeys.LEARN_MORE_CTA_LABEL)?.display,
        link: `${getPageRoute(functional.metaData?.urlAlias, language, linkVerticalRoute, ccProductPageRoutes)}?utm_source=${widgetTitle}&utm_medium=affiliate`,
      });
    }
    return {
      label: ctaButton?.label,
      link: `/external?url=${ctaButton?.link?.url}`,
    };
  };

  return (
    <>
      <Grid
        dataSelectorId="products"
        columns={1}
        gap="2px"
        rows="repeat(3, 1fr)"
        height="312px"
      >
        {products.map((product, index) => (
          <Cell bg="#f5f5f5" key={product.id} dataSelectorType="product">
            <Product
              {...product}
              ctaButton={getCtaButton(product)}
              language={language}
              widgetTitle={widgetTitle}
              trackCtaClick={() => trackCtaClick(tabLabel, product, index + 1)}
            />
          </Cell>
        ))}
      </Grid>
      <Footer
        dataSelectorId="vertical"
        disclaimerSection={disclaimerSection}
        button={seeMoreButton}
        widgetTitle={widgetTitle}
        onSeeMoreButtonClick={onSeeMoreButtonClick}
      />
    </>
  );
}

Vertical.propTypes = {
  list: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
    ctaBtnData: {
      linkVerticalRoute: PropTypes.string,
      staticText: PropTypes.shape([]),
      staticKeys: PropTypes.shape({}),
    },
  }),
  disclaimerSection: PropTypes.string,
  seeMoreButton: PropTypes.shape({}),
  trackCtaClick: PropTypes.func,
  language: PropTypes.string.isRequired,
  widgetTitle: PropTypes.string,
  trackTabChange: PropTypes.func,
  onSeeMoreButtonClick: PropTypes.func,
  tabLabel: PropTypes.string,
  ccProductPageRoutes: PropTypes.string.isRequired,
};

Vertical.defaultProps = {
  list: {
    ctaBtnData: {
      linkVerticalRoute: '',
      staticText: [],
      staticKeys: {
        LEARN_MORE_CTA_LABEL: '',
      },
    },
  },
};

export default Vertical;
